import React from 'react';
import Link from 'next/link';

import { IMenuByTypesItem } from '@r1-frontend/api-domru/api-content/v2/menu/by-types/dto/IMenuByTypesItem';
import * as ST from '@r1-frontend/entities/Layout/Header/mobile/styled';

interface IProps {
    menuItems: IMenuByTypesItem[],
    isDrop: boolean,
    colorText?: string,
    analytics: string,
    isBottom?: boolean,
    onClick: (item?: string, menuType?: string) => void,
    clickHandler?: () => void,
}

const TopMenu = ({
    menuItems,
    onClick,
    colorText,
    clickHandler,
    analytics,
}: IProps): JSX.Element => {

    return (
        <>
            {menuItems?.map(item => (
                <ST.MobilePartnersItem
                    key={`mobile-top-${item.id}`}
                    onClick={clickHandler}
                    data-test='top-menu-item-icons'
                >
                    <Link href={item.link} passHref>
                        <ST.IconTextBlock
                            onClick={() => onClick(item.title, analytics)}
                            color={colorText}
                        >
                            <ST.PromoImg>
                                <img src={item.image_icon} alt={item.title} />
                            </ST.PromoImg>
                            {item.title}
                        </ST.IconTextBlock>
                    </Link>
                </ST.MobilePartnersItem>
            ))}
        </>
    );
};

export default TopMenu;
